import React from 'react'
import RightArrow from '../../assets/images/right2.svg';
import leftArrow from '../../assets/images/leftArrow.svg';
import './style.css'
export default function AppNextButton({title,style,isLeft,onClick}) {
    

    return (
        <div onClick={onClick} style={style} className='app-next-button-main'>
         <img src={isLeft?leftArrow:RightArrow} className='button-arrow' />
        </div>
    )
}
